import { render, staticRenderFns } from "./ItemAddedToCartDialog.vue?vue&type=template&id=3f6c2331"
import script from "./ItemAddedToCartDialog.vue?vue&type=script&lang=js"
export * from "./ItemAddedToCartDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports